var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAiEmoji16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13149 2.87291C6.26908 2.54701 6.73092 2.54701 6.86851 2.87291L8.47331 6.67434C8.51085 6.76324 8.57926 6.83558 8.66593 6.87802L12.2662 8.64075C12.5651 8.78705 12.5651 9.21295 12.2662 9.35925L8.66593 11.122C8.57926 11.1644 8.51085 11.2368 8.47331 11.3257L6.86851 15.1271C6.73092 15.453 6.26908 15.453 6.13149 15.1271L4.52669 11.3257C4.48915 11.2368 4.42074 11.1644 4.33407 11.122L0.733761 9.35925C0.434949 9.21295 0.434949 8.78705 0.73376 8.64075L4.33407 6.87802C4.42074 6.83558 4.48915 6.76324 4.52669 6.67434L6.13149 2.87291Z",
    fill: "#1778E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7269 1.60071C11.8335 1.36625 12.1665 1.36625 12.2731 1.60071L12.8911 2.95999C12.9211 3.026 12.974 3.07891 13.04 3.10893L14.3993 3.7269C14.6337 3.83349 14.6337 4.16651 14.3993 4.2731L13.04 4.89107C12.974 4.92109 12.9211 4.974 12.8911 5.04001L12.2731 6.39929C12.1665 6.63375 11.8335 6.63375 11.7269 6.39929L11.1089 5.04001C11.0789 4.974 11.026 4.92109 10.96 4.89107L9.60071 4.2731C9.36625 4.16651 9.36625 3.83349 9.60071 3.7269L10.96 3.10893C11.026 3.07891 11.0789 3.026 11.1089 2.95999L11.7269 1.60071Z",
    fill: "#EE6821"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEmoji16);
export default __webpack_public_path__ + "static/media/ai-emoji-16.2fb2fcc5.svg";
export { ForwardRef as ReactComponent };